import { render } from "./OtiForOp.vue?vue&type=template&id=1ac26c82&scoped=true"
import script from "./OtiForOp.vue?vue&type=script&lang=js"
export * from "./OtiForOp.vue?vue&type=script&lang=js"

import "./OtiForOp.vue?vue&type=style&index=0&id=1ac26c82&scoped=true&lang=css"

import exportComponent from "D:\\OSOLE\\metalpro\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac26c82"]])

export default __exports__